"use client"

import React from 'react';
import styles from "./Paths.module.css";
import {Paths as PathType} from "@/types/Paths";
import SinglePath from "@/components/Paths/SinglePath/SinglePath";

export default function Paths(props: { data: PathType }) {
  const {data} = props
  return (
    <div className={styles.container}>
      {data.items.map((item) => {
          return <SinglePath className={styles.singlePath} key={item.id} data={item}/>
        }
      )}
    </div>
  )
}
